import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap"
import { FaSave } from "react-icons/fa"
import { MdCancel } from "react-icons/md"
import { Country, State, City } from "country-state-city"

const VendorModal = ({
  open,
  close,
  formData,
  setFormData,
  onSubmit,
  mode,
}) => {
  const [errors, setErrors] = useState({})
  const isView = mode === "view"

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  // ✅ VALIDATION UPDATED
  const validate = () => {
    let newErrors = {}

    if (!formData?.company) newErrors.company = "Company is required"

    if (!formData?.vendor_id) newErrors.vendor_id = "Vendor code is required"

    if (!formData?.name) newErrors.name = "Contact person is required"

    if (!formData?.phone) newErrors.phone = "Phone number is required"
    else if (!/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Enter valid 10 digit number"

    if (!formData?.email) newErrors.email = "Email is required"
    else if (!/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Invalid email format"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = () => {
    if (isView) return close()
    if (validate()) onSubmit()
  }

  return (
    <Modal isOpen={open} toggle={close} size="xl" centered>
      <ModalHeader toggle={close}>
        {isView ? "View" : formData?.id ? "Edit" : "Add"} Vendor
      </ModalHeader>

      <ModalBody>
        <Row>
          {/* ✅ Company */}
          <Col md="4">
            <Label>
              Company <span className="text-danger">*</span>
            </Label>
            <Input
              name="company"
              value={formData?.company || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.company && (
              <small className="text-danger">{errors.company}</small>
            )}
          </Col>

          {/* ✅ Vendor Code */}
          <Col md="4">
            <Label>
              Vendor Code <span className="text-danger">*</span>
            </Label>
            <Input
              name="vendor_id"
              value={formData?.vendor_id || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.vendor_id && (
              <small className="text-danger">{errors.vendor_id}</small>
            )}
          </Col>

          {/* ✅ Contact Person */}
          <Col md="4">
            <Label>
              Contact Person <span className="text-danger">*</span>
            </Label>
            <Input
              name="name"
              value={formData?.name || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.name && (
              <small className="text-danger">{errors.name}</small>
            )}
          </Col>

          {/* ✅ Email */}
          <Col md="4" className="mt-3">
            <Label>
              Email <span className="text-danger">*</span>
            </Label>
            <Input
              type="email"
              name="email"
              value={formData?.email || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.email && (
              <small className="text-danger">{errors.email}</small>
            )}
          </Col>

          {/* ✅ Phone */}
          <Col md="4" className="mt-3">
            <Label>
              Phone <span className="text-danger">*</span>
            </Label>
            <Input
              type="tel"
              name="phone"
              value={formData?.phone || ""}
              onChange={handleChange}
              disabled={isView}
              maxLength={10}
            />
            {errors.phone && (
              <small className="text-danger">{errors.phone}</small>
            )}
          </Col>

          {/* Buyer */}
          <Col md="4" className="mt-3">
            <Label>Buyer</Label>
            <Input
              name="buyer"
              value={formData?.buyer || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>

          {/* Class */}
          <Col md="4" className="mt-3">
            <Label>Class</Label>
            <Input
              name="class"
              value={formData?.class || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>

          {/* Industry */}
          <Col md="4" className="mt-3">
            <Label>Industry</Label>
            <Input
              name="industry"
              value={formData?.industry || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>

          {/* Balance */}
          <Col md="4" className="mt-3">
            <Label>Balance</Label>
            <Input
              type="number"
              name="balance"
              value={formData?.balance || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>

          {/* Address */}
          <Col md="12" className="mt-3">
            <Label>Address</Label>
            <Input
              type="textarea"
              name="address"
              rows="2"
              value={formData?.address || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>

          {/* Country */}
          <Col md="4" className="mt-3">
            <Label>Country</Label>
            <Input
              type="select"
              value={formData?.country || ""}
              onChange={e =>
                setFormData({
                  ...formData,
                  country: e.target.value,
                  state: "",
                  city: "",
                })
              }
              disabled={isView}
            >
              <option value="">Select Country</option>
              {Country.getAllCountries().map(c => (
                <option key={c.isoCode} value={c.isoCode}>
                  {c.name}
                </option>
              ))}
            </Input>
          </Col>

          {/* State */}
          <Col md="4" className="mt-3">
            <Label>State</Label>
            <Input
              type="select"
              value={formData?.state || ""}
              onChange={e =>
                setFormData({
                  ...formData,
                  state: e.target.value,
                  city: "",
                })
              }
              disabled={isView || !formData?.country}
            >
              <option value="">Select State</option>
              {State.getStatesOfCountry(formData?.country || "").map(s => (
                <option key={s.isoCode} value={s.isoCode}>
                  {s.name}
                </option>
              ))}
            </Input>
          </Col>

          {/* City */}
          <Col md="4" className="mt-3">
            <Label>City</Label>
            <Input
              type="select"
              name="city"
              value={formData?.city || ""}
              onChange={handleChange}
              disabled={isView || !formData?.state}
            >
              <option value="">Select City</option>
              {City.getCitiesOfState(
                formData?.country || "",
                formData?.state || ""
              ).map(c => (
                <option key={c.name} value={c.name}>
                  {c.name}
                </option>
              ))}
            </Input>
          </Col>

          {/* Zip */}
          <Col md="4" className="mt-3">
            <Label>Zip</Label>
            <Input
              name="zip"
              value={formData?.zip || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>

          {/* Fax */}
          <Col md="4" className="mt-3">
            <Label>Fax</Label>
            <Input
              name="fax"
              value={formData?.fax || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        {!isView && (
          <Button color="primary" onClick={handleSubmit}>
            <FaSave className="me-1" />
            Save
          </Button>
        )}
        <Button color="secondary" onClick={close}>
          <MdCancel className="me-1" />
          {isView ? "Close" : "Cancel"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default VendorModal
